// Incomplete non-conformities can be opened before Issue (and the later
// acceptance sections) exist. Reading .HOD on a missing section threw in the
// detail field list.

const ACCEPTED = "<span class='font-bold text-green'>Accepted</span>";

export function acceptanceMarkup(value, pendingLabel) {
    return value === true
        ? ACCEPTED
        : `<span class='font-bold text-red'>${pendingLabel}</span>`;
}

export function hodAcceptedIssue(item, pendingLabel) {
    return acceptanceMarkup(item?.Issue?.HOD, pendingLabel);
}

export function sectionAcceptance(item, section, pendingLabel) {
    const record = item?.[section];
    return `HISM: ${acceptanceMarkup(record?.DAM, pendingLabel)}<br>HoD: ${acceptanceMarkup(record?.HOD, pendingLabel)}`;
}

export function hodIssueNotYetAccepted(pageItem) {
    return !pageItem?.Issue?.HOD;
}
